import {createSlice} from '@reduxjs/toolkit'

export const pageNumberSlice = createSlice({
  name: 'pagination',
  initialState: {
    value: 1,
    savedProspectsValue: 1,
    opportunityBankValue: 1,
    attendeeSectionValue: 1,
    allConstituentsSavedProspectsValue: 1,
    recommendationEngineEngagementValue: 1
  },
  reducers: {
    getProspectsPageNumber: (state, action) => {
      state.value = action.payload
    },
    getSavedProspectsPageNumber: (state, action) => {
      state.savedProspectsValue = action.payload
    },
    setOpportunityListPageNumber: (state, action) => {
      state.opportunityBankValue = action.payload
    },
    setAttendeeListPageNumber: (state, action) => {
      state.attendeeSectionValue = action.payload
    },
    setAllConstituentsSavedProspectsListPageNumber: (state, action) => {
      state.allConstituentsSavedProspectsValue = action.payload
    },
    setRecommendationEngineEngagementListPageNumber: (state, action) => {
      state.recommendationEngineEngagementValue = action.payload
    }
  }
})

// Action creators are generated for each case reducer function
export const {
  getProspectsPageNumber,
  getSavedProspectsPageNumber,
  setOpportunityListPageNumber,
  setAttendeeListPageNumber,
  setAllConstituentsSavedProspectsListPageNumber,
  setRecommendationEngineEngagementListPageNumber
} = pageNumberSlice.actions

export default pageNumberSlice.reducer
